/* eslint-disable no-restricted-globals */

import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";
import { updateForwardedParams } from "src/utils/urlParams";
import {
  isAddonStoreEligible,
  isNoomSummitEligible,
  isProbioticsDeliveryEligible,
  isUpsEx360MedActive,
  isZumbaOfferEligible,
} from "src/utils/userSegment/features";
import { isInApp } from "src/utils/userSegment/in-app";
import goto from ".";

export type OffersParams = {
  userId?: string;
  acceptedCoursePackOffer?: boolean;
};

export type CollapsibleHeaderUrlParams = {
  showEmailReminder?: "noomPremium" | "noomSummit" | "snackDelivery" | false;
};

export default {
  noomPremium() {
    goto.layer("noom-premium");
  },
  inAppNoomPremium() {
    goto.layer("noom-premium-in-app-upgrade");
  },
  addOns({ showEmailReminder }: CollapsibleHeaderUrlParams) {
    updateForwardedParams({
      [CHECK_EMAIL_REMINDER_PARAM]: showEmailReminder ?? null,
    });
    goto.layer("addons");
  },

  probioticsDelivery() {
    goto.layer("probiotics-delivery");
  },

  zumbaOffer() {
    goto.layer("zumba-offer");
  },

  hrtSurvey() {
    goto.layer("hrt-survey");
  },

  fastForwardTrial({ showEmailReminder }: CollapsibleHeaderUrlParams) {
    updateForwardedParams({
      [CHECK_EMAIL_REMINDER_PARAM]: showEmailReminder ?? null,
    });
    goto.layer(`fast-forward`);
  },

  postSignupCrossSellExit() {
    if (isUpsEx360MedActive()) {
      goto.telehealthEnrollmentSetup();
      return;
    }

    if (isProbioticsDeliveryEligible()) {
      goto.probioticsDelivery();
      return;
    }
    if (isZumbaOfferEligible()) {
      goto.zumbaOffer();
      return;
    }
    if (isNoomSummitEligible()) {
      goto.layer("noom-summit");
      return;
    }
    if (isAddonStoreEligible()) {
      goto.addOns({ showEmailReminder: false });
      return;
    }
    if (isInApp()) {
      goto.nativePurchaseComplete();
      return;
    }
    goto.enrollment({});
  },
};
